module.exports = __webpack_public_path__ + "static/media/burn.d4885c0b.svg";